<article class="block type-flex form-wizard" *ngIf="project">
  <!-- <div _ngcontent-c1="" class="toolbar">
        <div class="toolbar">
            <a *ngIf="!(activeTab === 4 && selectedDetail)" [routerLink]="'/project/' + project.Id" class="toolbar-button type-close">
              <span class="icon is--icon-close">
                <svg class="icon-svg">
                    <use xlink:href="/assets/gfx/svg-sprite.svg#icon-close"></use>
                </svg>
              </span> Terug
            </a>

            <a *ngIf="activeTab === 4 && selectedDetail" (click)="selectedDetail = null" class="toolbar-button type-close">
              <span class="icon is--icon-close">
                <svg class="icon-svg">
                    <use xlink:href="/assets/gfx/svg-sprite.svg#icon-close"></use>
                </svg>
              </span> Terug
            </a>
        </div>
    </div> -->

  <div class="col-left">
    <header class="form-wizard-header">
      <h1 class="form-wizard-header-title">{{ project.Title || 'New project' }}</h1>
      <div class="form-wizard-header-text">
        <p [innerHTML]="project.Summary"></p>
      </div>
    </header>

    <ol class="form-wizard-chapters-list">
      <li class="form-wizard-chapter-list-item" [ngClass]="{ 'is--current': activeTab === 0 }">
        <a class="form-wizard-chapter-link" (click)="activeTab = 0">General</a>
      </li>
      <li class="form-wizard-chapter-list-item" [ngClass]="{ 'is--current': activeTab === 1 }">
        <a class="form-wizard-chapter-link" (click)="activeTab = 1">Credits</a>
      </li>
      <li class="form-wizard-chapter-list-item" [ngClass]="{ 'is--current': activeTab === 2 }">
        <a class="form-wizard-chapter-link" (click)="activeTab = 2">Technical</a>
      </li>
      <li class="form-wizard-chapter-list-item" [ngClass]="{ 'is--current': activeTab === 3 }">
        <a class="form-wizard-chapter-link" (click)="activeTab = 3">Files</a>
      </li>
      <li class="form-wizard-chapter-list-item" [ngClass]="{ 'is--current': activeTab === 4 }">
        <a class="form-wizard-chapter-link" (click)="activeTab = 4">Details</a>
      </li>
      <li class="form-wizard-chapter-list-item" [ngClass]="{ 'is--current': activeTab === 5 }">
        <a class="form-wizard-chapter-link" (click)="activeTab = 5">Save project</a>
      </li>
    </ol>

    <div class="form-wizard-button" *ngIf="project.Id > 0">
      <button class="block-group-folder-button" (click)="delete()">Delete project</button>
    </div>
  </div>

  <div class="col-right">
    <div class="row-small">
      <form class="form type-wizard" (submit)="saveProject()" #heroForm="ngForm">
        <!-- GENERAL -->
        <fieldset class="wizard-chapter" [ngClass]="{ 'is--active': activeTab === 0 }">
          <legend class="form-title">General</legend>
          <ul class="form-wizard-list">
            <li class="form-wizard-item">
              <label for="text_field_projecttitle" class="required wizard-label">Title project</label>
              <input
                type="text"
                id="text_field_projecttitle"
                name="Title project"
                placeholder="set project title without TP number."
                required
                [(ngModel)]="project.Title_EN"
              />
            </li>

            <li class="form-wizard-item">
              <ul class="form-col-list">
                <li class="form-col-item type--1-2">
                  <label for="text_field_projectTP" class="required wizard-label">TP-number</label>
                  <input type="text" id="text_field_projectTP" name="tp number" placeholder="xxx" required [(ngModel)]="project.TPNumber" />
                </li>
                <li class="form-col-item type--1-2">
                  <label for="text_field_projectTP" class="required wizard-label">Website order</label>
                  <input type="number" id="text_field_order" name="Order" placeholder="0" required [(ngModel)]="project.Order" />
                </li>
              </ul>
            </li>

            <li class="form-wizard-item">
              <ul class="form-col-list">
                <li class="form-col-item type--1-2">
                  <label for="text_field_year" class="wizard-label">Project phase</label>
                  <div class="switch-select type--full">
                    <span class="icon is--icon-angle-down">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-angle-down"></use>
                      </svg>
                    </span>
                    <select name="phase" [(ngModel)]="project.Phase" id="text_field_phase">
                      <option [ngValue]="0">Make a choice</option>
                      <option [ngValue]="1">Competition</option>
                      <option [ngValue]="2">Design</option>
                      <option [ngValue]="3">In progress</option>
                      <option [ngValue]="4">On site</option>
                      <option [ngValue]="5">Realized</option>
                    </select>
                  </div>
                </li>
                <li class="form-col-item type--1-2">
                  <label for="text_field_year" class="required wizard-label">Year</label>
                  <div class="switch-select type--full">
                    <span class="icon is--icon-angle-down">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-angle-down"></use>
                      </svg>
                    </span>
                    <select name="year" [(ngModel)]="project.Year" id="text_field_year" required [compareWith]="compareYears">
                      <option [ngValue]="0">Make a choice</option>
                      <option [ngValue]="y" *ngFor="let y of years">{{ y }}</option>
                    </select>
                  </div>
                </li>
              </ul>
            </li>
            <!-- Start & end dates -->
            <li class="form-wizard-item">
              <ul class="form-col-list">
                <li class="form-col-item type--1-2">
                  <label for="text_field_year" class="required wizard-label">Start date</label>
                  <div class="type--full">
                    <input
                      type="number"
                      id="text_field_startdate"
                      name="Start date"
                      placeholder="Start date"
                      required="required"
                      [ngModel]="project.StartDate ? (project.StartDate | date : 'yyyy') : ''"
                      (ngModelChange)="setStartDate($event)"
                    />
                  </div>
                </li>
                <li class="form-col-item type--1-2">
                  <label for="text_field_year" class="wizard-label">End date</label>
                  <div class="type--full">
                    <input
                      type="number"
                      id="text_field_enddate"
                      name="End date"
                      placeholder="End date"
                      [ngModel]="project.EndDate ? (project.EndDate | date : 'yyyy') : ''"
                      (ngModelChange)="setEndDate($event)"
                    />
                  </div>
                </li>
              </ul>
            </li>
            <li class="form-wizard-item">
              <label for="text_field_country" class="required wizard-label">Location</label>
              <div class="switch-select type--full">
                <span class="icon is--icon-angle-down">
                  <svg class="icon-svg">
                    <use xlink:href="/assets/gfx/svg-sprite.svg#icon-angle-down"></use>
                  </svg>
                </span>
                <select name="Project country" [(ngModel)]="project.Country" [compareWith]="compareFn">
                  <option [ngValue]="null">Make a choice</option>
                  <option [ngValue]="c" *ngFor="let c of fields.countries | orderByImpure : 'Name'">{{ c.Name }}</option>
                </select>
              </div>
            </li>
            <li class="form-wizard-item">
              <ul class="form-col-list">
                <li class="form-col-item type--1-2">
                  <label for="text_field_city" class="wizard-label">City (English)</label>
                  <input
                    type="text"
                    id="text_field_city_EN"
                    name="City_EN"
                    placeholder="Example: Rotterdam"
                    [(ngModel)]="project.City_EN"
                  />
                </li>
                <li class="form-col-item type--1-2">
                  <label for="text_field_city" class="wizard-label">City (Chinese)</label>
                  <input
                    type="text"
                    id="text_field_city_CN"
                    name="City_CN"
                    placeholder="Example: Rotterdam"
                    [(ngModel)]="project.City_CN"
                  />
                </li>
              </ul>
            </li>
            <li class="form-wizard-item">
              <app-maps-search [value]="location?.name" [location]="location" (found)="updateLocation($event)"></app-maps-search>
            </li>

            <li class="form-wizard-item">
              <label for="text_field_theme" class="required wizard-label">Themes</label>
              <ul class="form-col-list">
                <li class="form-col-item type--1-3" *ngFor="let s of themeOptions; let i = index">
                  <input
                    required="required"
                    class="required"
                    id="id_theme_{{ s.value.id }}"
                    name="themes"
                    [value]="s.value"
                    [checked]="s.checked"
                    (change)="s.checked = !s.checked"
                    type="checkbox"
                  />
                  <label for="id_theme_{{ s.value.id }}">
                    <span class="icon is--icon-check">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
                      </svg>
                    </span>
                    {{ s.value.title }}
                  </label>
                </li>
              </ul>
            </li>

            <li class="form-wizard-item">
              <label for="text_field_scale" class="required wizard-label">Scale</label>
              <ul class="form-col-list">
                <li class="form-col-item type--1-3" *ngFor="let s of scaleOptions; let i = index">
                  <input
                    required="required"
                    class="required"
                    id="id_scale_{{ s.value.Id }}"
                    name="scales"
                    [value]="s.value"
                    [checked]="s.checked"
                    (change)="s.checked = !s.checked"
                    type="checkbox"
                  />
                  <label for="id_scale_{{ s.value.Id }}">
                    <span class="icon is--icon-check">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
                      </svg>
                    </span>
                    {{ s.value.Name }}
                  </label>
                </li>
              </ul>
            </li>

            <li class="form-wizard-item">
              <label for="text_field_programs" class="required wizard-label">Programs</label>
              <ul class="form-col-list">
                <li class="form-col-item type--1-3" *ngFor="let p of programOptions; let i = index">
                  <input
                    required="required"
                    class="required"
                    id="id_program_{{ p.value.Id }}"
                    name="programs"
                    [value]="p.value"
                    [checked]="p.checked"
                    (change)="p.checked = !p.checked"
                    type="checkbox"
                  />
                  <label for="id_program_{{ p.value.Id }}">
                    <span class="icon is--icon-check">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
                      </svg>
                    </span>
                    {{ p.value.Name }}
                  </label>
                </li>
              </ul>
            </li>

            <li class="form-wizard-item">
              <label for="text_field_typologies" class="required wizard-label">Typologies</label>
              <ul class="form-col-list">
                <li class="form-col-item type--1-3" *ngFor="let t of typologyOptions; let i = index">
                  <input
                    required="required"
                    class="required"
                    id="id_typology_{{ t.value.Id }}"
                    name="typologies"
                    [value]="t.value"
                    [checked]="t.checked"
                    (change)="t.checked = !t.checked"
                    type="checkbox"
                  />
                  <label for="id_typology_{{ t.value.Id }}">
                    <span class="icon is--icon-check">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
                      </svg>
                    </span>
                    {{ t.value.Name }}
                  </label>
                </li>
              </ul>
            </li>

            <li class="form-wizard-item">
              <label for="text_field_scale" class="required wizard-label">Sustainability Certificates</label>
              <ul class="form-col-list">
                <li class="form-col-item type--1-3" *ngFor="let s of sustainabilityCertificateOptions; let i = index">
                  <input
                    required="required"
                    class="required"
                    id="id_sustainabilityCertificate_{{ s.value.Id }}"
                    name="sustainabilityCertificates"
                    [value]="s.value"
                    [checked]="s.checked"
                    (change)="s.checked = !s.checked"
                    type="checkbox"
                  />
                  <label for="id_sustainabilityCertificate_{{ s.value.Id }}">
                    <span class="icon is--icon-check">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-check"></use>
                      </svg>
                    </span>
                    {{ s.value.Name }}
                  </label>
                </li>
              </ul>
            </li>

            <li class="form-wizard-item">
              <ul class="form-col-list">
                <li class="form-col-item type--1-3">
                  <label for="text_field_size" class="required wizard-label">Program size total (m2)</label>
                  <input
                    type="number"
                    id="text_field_size"
                    name="size project"
                    placeholder="Example: 1000000"
                    required
                    [(ngModel)]="project.Size"
                  />
                </li>
                <li class="form-col-item type--1-3">
                  <label for="text_field_height" class="required wizard-label">Height (meters)</label>
                  <input
                    type="number"
                    id="text_field_budget"
                    name="Height"
                    class=""
                    placeholder="Example: 34"
                    required
                    [(ngModel)]="project.Height"
                  />
                </li>
                <li class="form-col-item type--1-3">
                  <label for="" class="wizard-label">Height (type)</label>

                  <input
                    required="required"
                    type="radio"
                    class="required"
                    id="id_low"
                    name="height type"
                    [value]="0"
                    required
                    [(ngModel)]="project.HeightType"
                  />
                  <label for="id_low">
                    <span class="icon is--icon-dot">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-dot"></use>
                      </svg>
                    </span>
                    Low rise
                  </label>

                  <input
                    required="required"
                    type="radio"
                    class="required"
                    id="id_high"
                    name="height type"
                    [value]="1"
                    required
                    [(ngModel)]="project.HeightType"
                  />
                  <label for="id_high">
                    <span class="icon is--icon-dot">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-dot"></use>
                      </svg>
                    </span>
                    High rise
                  </label>
                </li>
              </ul>
            </li>

            <!-- <li class="form-wizard-item">
              <label for="text_field_projectstory" class="required wizard-label">Project summary</label>
              <quill-editor
                name="Project summary"
                [(ngModel)]="project.Summary"
                [required]="true"
                id="text_field_projectSummary"
                [modules]="quillConfigLite">
              </quill-editor>
            </li>

            <li class="form-wizard-item">
              <label for="text_field_projectstory" class="required wizard-label">Project story</label>
              <!-- <textarea
                id="text_field_projectstory"
                autosize
                [minHeight]="120"
                [maxHeight]="360"
                name="Project story"
                class=""
                placeholder="Full story of this new project"
                [(ngModel)]="project.Description"
                required="required">
              </textarea> -->
            <!--quill-editor
                name="Project story"
                [(ngModel)]="project.Description"
                [required]="true"
                id="text_field_projectstory">
              </quill-editor>
            </li> -->

            <li class="form-wizard-item">
              <label for="text_field_budget" class="required wizard-label">Budget</label>
              <input
                type="text"
                id="text_field_budget"
                name="Budget"
                class=""
                placeholder="Example: € 1.000.000"
                required
                [(ngModel)]="project.Budget"
              />
            </li>
            <li class="form-wizard-item">
              <ul class="form-col-list">
                <li class="form-col-item type--1-3">
                  <label for="text_field_clientname" class="required wizard-label">Client name (English)</label>
                  <input
                    type="text"
                    id="text_field_clientname_EN"
                    name="ClientName_EN"
                    class=""
                    placeholder="Example: MVRDV"
                    required
                    [(ngModel)]="project.ClientName_EN"
                  />
                </li>
                <li class="form-col-item type--1-3">
                  <label for="text_field_clientname" class="required wizard-label">Client name (Chinese)</label>
                  <input
                    type="text"
                    id="text_field_clientname_CN"
                    name="ClientName_CN"
                    class=""
                    placeholder="Example: MVRDV"
                    required
                    [(ngModel)]="project.ClientName_CN"
                  />
                </li>
                <li class="form-col-item type--1-3">
                  <label for="" class="wizard-label">Confidentiality</label>
                  <input
                    required="required"
                    type="radio"
                    class="required"
                    id="id_private"
                    name="client type"
                    [value]="0"
                    required
                    [(ngModel)]="project.ClientType"
                  />
                  <label for="id_private">
                    <span class="icon is--icon-dot">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-dot"></use>
                      </svg>
                    </span>
                    Undisclosed
                  </label>
                  <input
                    required="required"
                    type="radio"
                    class="required"
                    id="id_public"
                    name="client type"
                    [value]="1"
                    required
                    [(ngModel)]="project.ClientType"
                  />
                  <label for="id_public">
                    <span class="icon is--icon-dot">
                      <svg class="icon-svg">
                        <use xlink:href="/assets/gfx/svg-sprite.svg#icon-dot"></use>
                      </svg>
                    </span>
                    Disclosed
                  </label>
                </li>
              </ul>
            </li>
          </ul>
        </fieldset>

        <!-- CREDITS -->
        <fieldset class="wizard-chapter" [ngClass]="{ 'is--active': activeTab === 1 }">
          <legend class="form-title">Credits</legend>
          <ul class="form-wizard-list">
            <!--   Select phase   -->
            <!-- <li class="form-wizard-item">
              <label for="text_field_country" class="required wizard-label">Project phase</label>
              <div class="switch-select">
                <span class="icon is--icon-angle-down">
                  <svg class="icon-svg">
                      <use xlink:href="assets/gfx/svg-sprite.svg#icon-angle-down"></use>
                  </svg>
                </span>
                <select name="project-phase" [(ngModel)]="project.Phase">
                  <option value="0">Make a choice</option>
                  <option value="1">SD</option>
                  <option value="2">PD</option>
                  <option value="3">DD</option>
                  <option value="4">TD</option>
                  <option value="5">Completed</option>
                </select>
              </div>
            </li> -->

            <!--   group containers
            <li class="form-wizard-item">
              <label for="text_field_team" class="required wizard-label">Add team members</label>

              <div class="form-repeat">
                <table class="form-repeat-table type-border">
                  <thead class="form-repeat-table-thead">
                    <tr class="form-repeat-table-row">
                      <th class="form-repeat-table-th">Phase</th>
                      <th class="form-repeat-table-th" style="width: 100%;">Team</th>
                      <th class="form-repeat-table-th"><span class='is--hidden'>options</span></th>
                    </tr>
                  </thead>
                  <tbody class="form-repeat-table-tbody">
                    <tr class="form-repeat-table-row" *ngFor="let team of project.Teams; let i = index">
                      <td class="form-repeat-table-col">

                        <div class="switch-select">
                          <span class="icon is--icon-angle-down">
                            <svg class="icon-svg">
                                <use xlink:href="assets/gfx/svg-sprite.svg#icon-angle-down"></use>
                            </svg>
                          </span>
                          <select class="" id="" [name]="'phase-type-' + i" [(ngModel)]="team.Phase">
                            <option value="0">Make a choice</option>
                            <option value="1">SD</option>
                            <option value="2">PD</option>
                            <option value="3">DD</option>
                            <option value="4">TD</option>
                            <option value="5">Completed</option>
                          </select>
                        </div>

                      </td>
                      <td class="form-repeat-table-col">

                        <div class="form-datepicker-range form-repeat-row">
                            <div class="form-datepicker-range-item">
                                <label class="wizard-label" for="{{'PhaseStart_' + i}}">Start</label>
                                <my-datepicker [options]="datePickerOptions" [(ngModel)]="team.PhaseStart" placeholder="Start" [name]="'PhaseStart_' + i"></my-datepicker>
                              </div>
                            <div class="form-datepicker-range-item">
                                <label class="wizard-label" for="{{'PhaseStart_' + i}}">End</label>
                                <my-datepicker [options]="datePickerOptions" [(ngModel)]="team.PhaseEnd" placeholder="End" [name]="'PhaseStart_' + i"></my-datepicker>
                            </div>
                        </div>

                        <div class="ng-select-wrapper form-repeat-row">
                          <ng-select
                            [multiple]="true"
                            [active]="team.selectedMembers"
                            [items]="employees | selectFields"
                            (data)="updatePhase($event, i)"
                            placeholder="Search and select employees">
                          </ng-select>
                          <span class="ngselect-icon icon is--icon-search">
                              <svg class="icon-svg">
                                  <use xlink:href="/assets/gfx/svg-sprite.svg#icon-search"></use>
                              </svg>
                          </span>
                        </div>

                        <div>
                          <input type="text" placeholder="External teams" [(ngModel)]="team.ExternalTeams" [name]="'ExternalTeams_' + i">
                        </div>
                      </td>
                      <td>
                        <button class="button type-icon-only-small" (click)="removePhase(i)">
                          delete row
                          <span class="icon icon--close is--icon-close">
                            <svg class="icon-svg">
                                <use xlink:href="assets/gfx/svg-sprite.svg#icon-close"></use>
                            </svg>
                          </span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <a class="button type-add-row variant-dark-color" (click)="addPhase(0)">
                  Add phase
                  <span class="icon icon--right icon--plus is--icon-plus">
                    <svg class="icon-svg">
                        <use xlink:href="assets/gfx/svg-sprite.svg#icon-plus"></use>
                    </svg>
                  </span>
                 </a>
              </div>
            </li>
          -->

            <li class="form-wizard-item">
              <!-- <label for="text_field_team" class="required wizard-label">Add team members</label> -->
              <button *ngIf="!allGroupsCollapsed" class="button type-collapse-all variant-dark-color" (click)="collapseAll()">
                Collapse all
              </button>
              <button *ngIf="allGroupsCollapsed" class="button type-collapse-all variant-dark-color" (click)="collapseAll()">
                Expand all
              </button>

              <div class="form-repeat">
                <table class="form-repeat-table type-border">
                  <thead class="form-repeat-table-thead">
                    <tr class="form-repeat-table-row">
                      <th class="form-repeat-table-th">Phase</th>
                      <th class="form-repeat-table-th" style="width: 100%">Team</th>
                      <th class="form-repeat-table-th"><span class="is--hidden">options</span></th>
                    </tr>
                  </thead>
                  <tbody class="form-repeat-table-tbody" ngxDroppable [model]="project.Teams">
                    <!-- <tr class="form-repeat-table-row"
                      *ngFor="let team of project.Teams | orderByImpure: 'Order'; let i = index"
                      (dragstart)="dragStart($event, i)"
                      (dragover)="dragOver($event, i)"
                      draggable="true"> -->
                    <tr
                      class="form-repeat-table-row"
                      *ngFor="let team of project.Teams | orderByImpure : 'Order'; let i = index"
                      ngxDraggable
                      [model]="team"
                      [class.collapsed]="team.groupCollapsed"
                    >
                      <!-- <td class="form-repeat-table-col">

                      <div class="switch-select">
                        <span class="icon is--icon-angle-down">
                          <svg class="icon-svg">
                              <use xlink:href="assets/gfx/svg-sprite.svg#icon-angle-down"></use>
                          </svg>
                        </span>
                        <select class="" id="" [name]="'phase-type-' + i" [(ngModel)]="team.Phase">
                          <option value="0">Make a choice</option>
                          <option value="1">SD</option>
                          <option value="2">PD</option>
                          <option value="3">DD</option>
                          <option value="4">TD</option>
                          <option value="5">Completed</option>
                        </select>
                      </div>

                    </td> -->
                      <!-- start group -->
                      <td class="form-repeat-table-col group">
                        <!-- collapse button group -->
                        <a class="toggle-tab button type-icon-only-small" (click)="team.groupCollapsed = !team.groupCollapsed">
                          <span class="toggle-tab__icon" [class.is--close]="team.groupCollapsed"></span>
                        </a>

                        <div class="group__container" [class.is--collapsed]="team.groupCollapsed">
                          <div class="group__header">
                            <h1 class="group__header__title" [innerHtml]="team.Title ? team.Title : 'New group'"></h1>

                            <a class="group__header__close button type-icon-only-small" (click)="removeGroup(i)">
                              <span class="icon icon--close is--icon-close">
                                <svg class="icon-svg">
                                  <use xlink:href="assets/gfx/svg-sprite.svg#icon-close"></use>
                                </svg>
                              </span>
                            </a>
                          </div>
                          <!-- <div class="form-datepicker-range form-repeat-row">
                            <div class="form-datepicker-range-item">
                                <label class="wizard-label" for="{{'PhaseStart_' + i}}">Start</label>
                                <my-datepicker [options]="datePickerOptions" [(ngModel)]="team.PhaseStart" placeholder="Start" [name]="'PhaseStart_' + i"></my-datepicker>
                              </div>
                            <div class="form-datepicker-range-item">
                                <label class="wizard-label" for="{{'PhaseStart_' + i}}">End</label>
                                <my-datepicker [options]="datePickerOptions" [(ngModel)]="team.PhaseEnd" placeholder="End" [name]="'PhaseStart_' + i"></my-datepicker>
                            </div>
                        </div> -->
                          <form class="group__form">
                            <label class="wizard-label">Group</label>
                            <input
                              type="text"
                              placeholder="Enter group title (English)"
                              [(ngModel)]="team.Title_EN"
                              [name]="'ExternalTeams_' + i"
                            />
                            <input
                              type="text"
                              placeholder="Enter group title (Chinese)"
                              [(ngModel)]="team.Title_CN"
                              [name]="'ExternalTeams_CN_' + i"
                            />
                          </form>

                          <form class="group__form">
                            <label class="wizard-label">Phase (optional)</label>
                            <div class="switch-select">
                              <span class="icon is--icon-angle-down">
                                <svg class="icon-svg">
                                  <use xlink:href="assets/gfx/svg-sprite.svg#icon-angle-down"></use>
                                </svg>
                              </span>
                              <select class="" id="" [name]="'phase-type-' + i" [(ngModel)]="team.Phase">
                                <option value="0">Make a choice</option>
                                <option value="1">Competition</option>
                                <option value="2">Design</option>
                                <option value="3">In progress</option>
                                <option value="4">On site</option>
                                <option value="5">Realized</option>
                              </select>
                            </div>
                          </form>
                          <form class="group__form">
                            <label class="wizard-label">Members</label>
                            <tag-input
                              [name]="'phase-members-' + i"
                              [(ngModel)]="team.Members"
                              [displayBy]="'Name_EN'"
                              [identifyBy]="'Name_EN'"
                              placeholder="Search and select employees"
                              [onAdding]="onMemberAdded"
                            >
                              <tag-input-dropdown
                                [autocompleteItems]="fields.employees"
                                [showDropdownIfEmpty]="true"
                                [displayBy]="'Name_EN'"
                                [identifyBy]="'Name_EN'"
                              >
                                <ng-template let-item="item" let-index="index">
                                  {{ item.Name_EN }}
                                </ng-template>
                              </tag-input-dropdown>
                            </tag-input>
                          </form>

                          <div class="group__subgroup" *ngFor="let subTeam of team.Subgroups; let i2 = index">
                            <!-- collapse button subgroup -->
                            <a class="toggle-tab button type-icon-only-small" (click)="subTeam.groupCollapsed = !subTeam.groupCollapsed">
                              <span class="toggle-tab__icon" [class.is--close]="subTeam.groupCollapsed"></span>
                            </a>

                            <div class="group__container" [class.is--collapsed]="subTeam.groupCollapsed">
                              <div class="group__subgroup__header">
                                <h1
                                  class="group__subgroup__header__title"
                                  [innerHtml]="subTeam.Title ? subTeam.Title : 'New subgroup'"
                                ></h1>

                                <a class="group__subgroup__header__close button type-icon-only-small" (click)="removeGroup(i, i2)">
                                  <span class="icon icon--close is--icon-close">
                                    <svg class="icon-svg">
                                      <use xlink:href="assets/gfx/svg-sprite.svg#icon-close"></use>
                                    </svg>
                                  </span>
                                </a>
                              </div>

                              <form class="group__subgroup__form">
                                <label class="wizard-label">Subgroup</label>
                                <input
                                  type="text"
                                  placeholder="Enter subgroup title"
                                  [(ngModel)]="subTeam.Title_EN"
                                  [name]="'ExternalTeams_' + i2"
                                />

                                <input
                                  type="text"
                                  placeholder="Enter subgroup title (Chinese)"
                                  [(ngModel)]="subTeam.Title_CN"
                                  [name]="'ExternalTeams_CN_' + i2"
                                />
                              </form>

                              <form class="group__subgroup__form">
                                <label class="wizard-label">Members</label>
                                <tag-input
                                  [name]="'phase-submembers-' + i2"
                                  [(ngModel)]="subTeam.Members"
                                  [displayBy]="'Name_EN'"
                                  [identifyBy]="'Name_EN'"
                                  placeholder="Search and select employees"
                                  [onAdding]="onMemberAdded"
                                >
                                  <tag-input-dropdown
                                    [autocompleteItems]="fields.employees"
                                    [showDropdownIfEmpty]="true"
                                    [displayBy]="'Name_EN'"
                                    [identifyBy]="'Name_EN'"
                                  >
                                    <ng-template let-item="item" let-index="index">
                                      {{ item.Name_EN }}
                                    </ng-template>
                                  </tag-input-dropdown>
                                </tag-input>
                              </form>
                            </div>
                            <!-- <div class="ng-select-wrapper form-repeat-row">
                          <ng-select
                            [multiple]="true"
                            [active]="team.selectedMembers"
                            [items]="employees | selectFields"
                            (data)="updatePhase($event, i)"
                            placeholder="Search and select employees">
                          </ng-select>
                          <span class="ngselect-icon icon is--icon-search">
                              <svg class="icon-svg">
                                  <use xlink:href="/assets/gfx/svg-sprite.svg#icon-search"></use>
                              </svg>
                          </span>
                        </div> -->
                          </div>

                          <a class="group__add-button button type-add-row variant-dark-color" (click)="addGroup(0, i)">
                            Add subgroup
                            <span class="icon icon--right icon--plus is--icon-plus">
                              <svg class="icon-svg">
                                <use xlink:href="assets/gfx/svg-sprite.svg#icon-plus"></use>
                              </svg>
                            </span>
                          </a>
                        </div>
                      </td>
                      <!-- end group -->
                      <!-- <td>
                      <button class="button type-icon-only-small" (click)="removePhase(i)">
                        delete row
                        <span class="icon icon--close is--icon-close">
                          <svg class="icon-svg">
                              <use xlink:href="assets/gfx/svg-sprite.svg#icon-close"></use>
                          </svg>
                        </span>
                      </button>
                    </td> -->
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>

          <a class="button type-add-row variant-dark-color" (click)="addGroup(0)">
            Add group
            <span class="icon icon--right icon--plus is--icon-plus">
              <svg class="icon-svg">
                <use xlink:href="assets/gfx/svg-sprite.svg#icon-plus"></use>
              </svg>
            </span>
          </a>
        </fieldset>

        <!-- TECHNICAL -->
        <fieldset class="wizard-chapter" [ngClass]="{ 'is--active': activeTab === 2 }">
          <legend class="form-title">Technical</legend>
          <ul class="form-wizard-list">
            <li class="form-wizard-item">
              <label for="text_field_concelt" class="required wizard-label">Concepts</label>
              <div class="form-repeat">
                <table class="form-repeat-table">
                  <thead class="form-repeat-table-thead">
                    <tr class="form-repeat-table-row">
                      <th class="form-repeat-table-th">Choose concepts</th>
                    </tr>
                  </thead>
                  <tbody class="form-repeat-table-tbody">
                    <tr class="form-repeat-table-row">
                      <td class="form-repeat-table-col">
                        <div class="ng-select-wrapper">
                          <ng-select
                            [multiple]="true"
                            name="technical_concepts"
                            [(ngModel)]="selectedConcepts"
                            bindLabel="text"
                            bindValue="id"
                            [compareWith]="compareFn"
                            [items]="fields.concepts | selectFields"
                            (change)="updateNgSelect($event, 'Concepts')"
                            placeholder="No details selected"
                          ></ng-select>
                          <span class="ngselect-icon icon is--icon-search">
                            <svg class="icon-svg">
                              <use xlink:href="/assets/gfx/svg-sprite.svg#icon-search"></use>
                            </svg>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>

            <li class="form-wizard-item">
              <label for="text_field_material" class="required wizard-label">Materials</label>
              <div class="form-repeat">
                <table class="form-repeat-table">
                  <thead class="form-repeat-table-thead">
                    <tr class="form-repeat-table-row">
                      <th class="form-repeat-table-th">Choose materials</th>
                    </tr>
                  </thead>
                  <tbody class="form-repeat-table-tbody">
                    <tr class="form-repeat-table-row">
                      <td class="form-repeat-table-col">
                        <div class="ng-select-wrapper">
                          <ng-select
                            [multiple]="true"
                            bindLabel="text"
                            bindValue="id"
                            name="technical_materials"
                            [(ngModel)]="selectedMaterials"
                            [compareWith]="compareFn"
                            [items]="fields.materials | selectFields"
                            (change)="updateNgSelect($event, 'Materials')"
                            placeholder="No details selected"
                          ></ng-select>

                          <span class="ngselect-icon icon is--icon-search">
                            <svg class="icon-svg">
                              <use xlink:href="/assets/gfx/svg-sprite.svg#icon-search"></use>
                            </svg>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>

            <li class="form-wizard-item">
              <label for="text_field_structure" class="required wizard-label">Structures</label>
              <div class="form-repeat">
                <table class="form-repeat-table">
                  <thead class="form-repeat-table-thead">
                    <tr class="form-repeat-table-row">
                      <th class="form-repeat-table-th">Choose structures</th>
                    </tr>
                  </thead>
                  <tbody class="form-repeat-table-tbody">
                    <tr class="form-repeat-table-row">
                      <td class="form-repeat-table-col">
                        <div class="ng-select-wrapper">
                          <ng-select
                            [multiple]="true"
                            [(ngModel)]="selectedStructures"
                            name="technical_structures"
                            bindLabel="text"
                            bindValue="id"
                            [compareWith]="compareFn"
                            [items]="fields.structures | selectFields"
                            (change)="updateNgSelect($event, 'Structures')"
                            placeholder="No details selected"
                          ></ng-select>

                          <span class="ngselect-icon icon is--icon-search">
                            <svg class="icon-svg">
                              <use xlink:href="/assets/gfx/svg-sprite.svg#icon-search"></use>
                            </svg>
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </li>
          </ul>
        </fieldset>

        <!-- FILES -->
        <fieldset class="wizard-chapter" [ngClass]="{ 'is--active': activeTab === 3 }">
          <legend class="form-title">Add files</legend>
          <ul class="form-wizard-list">
            <li class="form-wizard-item">
              <app-file-editor [files]="project.Files" [type]="'project'" [contentId]="project.Id"></app-file-editor>
            </li>
          </ul>
        </fieldset>

        <fieldset class="wizard-chapter" [ngClass]="{ 'is--active': activeTab === 4 }">
          <legend class="form-title">Add Details</legend>

          <div *ngIf="!selectedDetail">
            <button class="button variant-dark-color teaser-item" type="button" (click)="addDetail()">
              <span class="icon icon--left is--icon-plus">
                <svg class="icon-svg">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/assets/gfx/svg-sprite.svg#icon-plus"></use>
                </svg>
              </span>
              Add detail
            </button>

            <ul class="teasers-group type-flex-3">
              <li class="item teaser-item is--clickable" *ngFor="let d of project.Details" (click)="editDetail($event, d)">
                <app-teaser-block [teaserItem]="d | teaserItem : true"></app-teaser-block>
              </li>
            </ul>
          </div>

          <app-detail-form-inline
            *ngIf="selectedDetail"
            [detail]="selectedDetail"
            [materials]="fields.materials"
            [elements]="fields.detailCategories"
            [structures]="fields.detailStructures"
            (onSave)="saveDetail($event)"
            (onCancel)="selectedDetail = null"
          ></app-detail-form-inline>
        </fieldset>

        <fieldset class="wizard-chapter" [ngClass]="{ 'is--active': activeTab === 5 }">
          <legend class="form-title">
            <em>Save project:</em>
            TP-{{ project.TPNumber }} {{ project.Title }}
          </legend>
          <ul class="form-wizard-list">
            <li class="form-wizard-item">
              <div class="panel panel-success" *ngIf="result == 'updated' || result == 'created'">
                <p>
                  Thank you! Your project is successfully
                  <span *ngIf="result == 'updated'">updated!</span>
                  <span *ngIf="result == 'created'">saved!</span>
                </p>
                <a class="button variant-dark-color" type="button" [routerLink]="'/project/' + project.Id">
                  <span class="icon icon--left is--icon-arrow-left">
                    <svg class="icon-svg">
                      <use xlink:href="/assets/gfx/svg-sprite.svg#icon-arrow-left"></use>
                    </svg>
                  </span>
                  Back to project
                </a>
              </div>
            </li>
            <li class="form-wizard-item">
              <button class="button variant-dark-color button-save-from" type="submit" [ngClass]="{ 'is--saved': saving == true }">
                Save project
              </button>
            </li>
          </ul>
        </fieldset>

        <footer class="wizard-pagination" *ngIf="result != 'updated' && result != 'created'">
          <button type="button" class="button variant-dark-color" (click)="activeTab = activeTab - 1" *ngIf="activeTab > 0">
            <span class="icon icon--left is--icon-arrow-left">
              <svg class="icon-svg">
                <use xlink:href="/assets/gfx/svg-sprite.svg#icon-arrow-left"></use>
              </svg>
            </span>
            Previous
          </button>

          <button type="button" class="button variant-dark-color" (click)="activeTab = activeTab + 1" *ngIf="activeTab < 5">
            Next
            <span class="icon icon--right is--icon-arrow-right">
              <svg class="icon-svg">
                <use xlink:href="/assets/gfx/svg-sprite.svg#icon-arrow-right"></use>
              </svg>
            </span>
          </button>
        </footer>
      </form>
    </div>
  </div>
</article>
